export default __webpack_public_path__ + "assets/authBackground.7849c81fd8d07555b5f3be4b9701d182.jpg";